/**
 * DetailPoster component.
 */
import DeviceConfig from '@devices/config';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

/**
 * Styled detail poster.
 */
const DetailPoster = styled.img<React.CSSProperties>`
  border: ${1 * Screen.widthRatio}px solid #6b6b6b;
  border-radius: ${20 * Screen.widthRatio}px;
  height: ${350 * Screen.widthRatio}px;
  width: ${230 * Screen.widthRatio}px;
  ${() => {
    return !DeviceConfig.capabilities?.image?.disableFitCover
      ? 'object-fit:cover'
      : '';
  }};
`;

export default withImage(DetailPoster, true);
